// extracted by mini-css-extract-plugin
export default {"form":"list-page_form__b9IXo","btn_wide":"list-page_btn_wide__UBRTt","wrapper":"list-page_wrapper__-y7+i","series":"list-page_series__VQQBT","item":"list-page_item__PM5Od"};